// Токены дизайн-системы SmartPark OS. Значения сняты с компонентов в Figma
// (страница «SmartPark OS Design System»): Button, Select, Card, Modal, Badge,
// Table*, Tabs, Link Input. Менять цвет, радиус или шрифт всего приложения -
// здесь; тема (./index.js) раздаёт их MUI-компонентам.

export const colors = {
  primary: '#2563EB',
  primaryHover: '#1D4ED8',
  primaryLight: '#E8F0FF',
  // Рамка полей при наведении и фокусе - так в состояниях Select
  focus: '#6792F4',

  text: '#272E35',
  textSecondary: '#555F6D',
  textMuted: '#7E8B99',
  textDisabled: '#9EA8B3',
  // Текст на кнопке Outline
  textButton: '#4A545E',

  border: '#CFD6DD',
  borderHover: '#9EA8B3',
  divider: '#E9ECEF',
  surface: '#F5F7F9',
  surfaceHover: '#FBFCFD',
  white: '#FFFFFF',

  // Затемнение под модальными окнами
  backdrop: 'rgba(25, 39, 58, 0.6)',

  success: '#1D7C4D',
  successBg: '#CFF2CF',
  warning: '#F59638',
  warningBg: '#FFE8D1',
  error: '#C53434',
  errorBorder: '#F26464',
  errorBg: '#FEE6E6',
}

export const radius = {
  input: 8,
  button: 8,
  menu: 8,
  tooltip: 6,
  card: 12,
  modal: 12,
  pill: 999,
}

// Высота кнопок и полей ввода: в макете Button 37, Link Input 36 - берём 36,
// чтобы поле и кнопка в одной строке выравнивались
export const controlHeight = {
  default: 36,
  small: 28,
}

export const fontFamily = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
